import { Component, OnInit } from '@angular/core';
import {BookingHeaderTitleServiceService} from '../../booking-header/booking-header-title-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../api.service';

@Component({
  selector: 'app-waiting-list-expiry-keep',
  templateUrl: './waiting-list-expiry-keep.component.html',
  styleUrls: ['./waiting-list-expiry-keep.component.css']
})
export class WaitingListExpiryKeepComponent implements OnInit {

  status: string;

  constructor(private titleService: BookingHeaderTitleServiceService,
              private route: ActivatedRoute,
              private apiService: ApiService) { }

  ngOnInit(): void {
    this.titleService.setTitle('Waiting List Preferences');

    this.status = 'Saving your request';

    this.route.params.subscribe(params => {
      this.apiService.keepWaitingListExpiry(params.waitingListExpiryId).subscribe(() => {
        this.status = 'We\'ll keep you on our waiting list and continue to look for your perfect lesson space. For an overview of your bookings and waiting list requests, please login to your account.';
      });
    });
  }

}
